import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './TableSkeleton.module.css';

export const TableSkeleton = ({ rows = 8, columns = 4, height = '300px' }) => {
  // Generate stable keys once on component mount
  const keys = useMemo(() => {
    const headerKeys = Array(columns)
      .fill()
      .map((_, i) => `header-cell-${i}-${Date.now()}`);
    const rowKeys = Array(rows)
      .fill()
      .map((_, i) => `row-${i}-${Date.now()}`);
    const cellKeys = Array(rows)
      .fill()
      .map(() =>
        Array(columns)
          .fill()
          .map((_, j) => `cell-${j}-${Date.now()}`)
      );

    return { headerKeys, rowKeys, cellKeys };
  }, [rows, columns]);

  return (
    <div className={styles.skeletonTable} style={{ minHeight: height }}>
      <div className={styles.skeletonHeader}>
        {Array(columns)
          .fill()
          .map((_, i) => (
            <div key={keys.headerKeys[i]} className={styles.skeletonHeaderCell}></div>
          ))}
      </div>
      <div className={styles.skeletonBody}>
        {Array(rows)
          .fill()
          .map((_, rowIndex) => (
            <div key={keys.rowKeys[rowIndex]} className={styles.skeletonRow}>
              {Array(columns)
                .fill()
                .map((_, colIndex) => (
                  <div
                    key={keys.cellKeys[rowIndex][colIndex]}
                    className={styles.skeletonCell}
                  ></div>
                ))}
            </div>
          ))}
      </div>
    </div>
  );
};

TableSkeleton.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  height: PropTypes.string,
};
